import { render, staticRenderFns } from "./SkupTema2Base.vue?vue&type=template&id=6b968ef4&scoped=true&"
import script from "./SkupTema2Base.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b968ef4",
  null
  
)

export default component.exports